const content = (
  <div>
    <p>
      Cette formation vise à vous doter des compétences et des stratégies
      nécessaires pour naviguer avec efficacité et sensibilité à travers toutes
      les étapes des situations de crise et d'incertitude. Vous serez formé à
      identifier, prévenir et anticiper les crises en analysant les risques et
      les menaces potentielles.
    </p>

    <h2>Public Concerné</h2>
    <p>Cette formation s'adresse aux managers d'équipes </p>
    <h2>Prérequis</h2>
    <p>Des connaissances en management</p>
    <h2>Objectifs Pédagogiques</h2>
    <p>À la fin de cette formation, le participant saura :</p>
    <ul>
      <li>
        Appréhender les diverses phases de la gestion de crise et d'incertitude.
      </li>
      <li>
        Développer une perspective plus large et soutenir les collaborateurs
        face aux changements.
      </li>
      <li>Piloter efficacement la résolution et la clôture d'une crise.</li>
      <li>
        Initier des stratégies proactives pour éviter les futures situations de
        crise.
      </li>
    </ul>

    <p>Dates : Définies selon planning</p>
    <p>
      Durée : 2 jours de 9 h00 à 17h, soit 7 heures effectives de formation par
      jour
    </p>
    <p>
      Durée : A distance, avec ou sans regroupements, en partie à distance et en
      partie en présentiel
    </p>
    <p>
      Organisation : A distance, avec ou sans regroupements, en partie à
      distance et en partie en présentiel
    </p>
    <p>En intra ou inter entreprise</p>
    <p>Taille du groupe : jusqu’à 10 stagiaires</p>
    <p>Lieux</p>
    <p>En intra : Chez le client</p>
    <p>En inter : Des salles de formation sont proposées à Paris</p>

    <h2>Accessibilité</h2>
    <p>
      Pour toute situation de handicap merci de nous contacter pour envisager la
      faisabilité
    </p>
    <h2>Délai et modalités d'accès</h2>
    <p>
      Jusqu'à 48h avant le début de la formation et en fonction des plannings
    </p>
    <h2>Tarifs</h2>
    <p>1.200 Euros hors taxes pour les 2 jours de formation par stagiaire</p>

    <h2>1/ Comprendre les différentes situations de crise</h2>
    <p>
      Exploration des divers scénarios de crise et d'incertitude, tels que la
      réorganisation, le déménagement, ou la fermeture de site.
    </p>
    <p>
      Compréhension des enjeux et particularités propres à chaque type de
      situation.
    </p>
    <h3>Exercices pratiques :</h3>
    <p>
      Collaboration en groupe pour examiner les diverses crises et incertitudes
      déjà expérimentées.
    </p>
    <h2>2/ Prévoir et atténuer les risques de crise</h2>
    <p>Comprendre les phases d'une crise.</p>
    <p>Reconnaître les signaux d'alerte et les facteurs déclencheurs.</p>
    <p>Identifier les éléments qui peuvent intensifier la crise.</p>
    <p>
      Mettre en place des mesures préventives : création d'une cellule de crise.
    </p>
    <p>Détecter les points faibles et évaluer les dangers potentiels.</p>
    <p>Dresser une cartographie des menaces.</p>
    <p>Gérer la résolution et la conclusion de la crise.</p>
    <p>Conduire un audit approfondi de l’équipe ou de l'entreprise.</p>
    <p>
      Examiner les pratiques des organisations les plus créatrices et
      innovantes.
    </p>
    <p>Comprendre le potentiel créatif.</p>
    <h3>Exercices pratiques :</h3>
    <p>
      A partir d’in cas concret, identifier les signaux avant-coureurs de la
      crise, repérer les facteurs déclencheurs et comprendre les éléments qui
      peuvent aggraver la situation.
    </p>
    <h2>3/ Optimiser la gestion d'équipe face à l'incertitude</h2>
    <p>Quatre niveaux d'incertitude.</p>
    <p>Préparation des équipes à l'incertitude.</p>
    <p>Planification face à l'incertitude.</p>
    <p>Approche systémique du raisonnement.</p>
    <p>Compétences clés du leader en incertitude.</p>
    <p>Cinq dimensions prioritaires.</p>
    <p>Outils décisionnels : anticipation, confiance, écoute.</p>

    <h3>Cas pratique :</h3>
    <p>
      Le développement d'un plan de continuité des opérations face à une crise
      inattendue/ Renforcer la capacité des managers à réagir rapidement et
      efficacement en cas de crise majeure affectant les opérations de
      l'entreprise.
    </p>
    <h2>4/ Gérer et soutenir les émotions des membres de l'équipe.</h2>
    <p>
      Fonctionnements et perturbations psychologiques en contexte professionnel.
    </p>
    <p>Stratégies de défense en périodes de crise et d'incertitude.</p>
    <p>Maîtrise du stress en contextes de crise.</p>
    <p>
      Exploiter les émotions : analyser les siennes et encadrer celles des
      autres.
    </p>
    <p>Gestion des conflits et apaisement des tensions durant les crises.</p>

    <h3>Cas pratique :</h3>
    <p>
      Une situation de crise soudaine, comme une panne majeure des systèmes
      informatiques, a entraîné des retards significatifs dans un projet
      critique. Les membres de l'équipe ressentent une pression accrue et
      montrent des signes de stress et de frustration. Certains conflits
      émergent entre les membres de l'équipe à cause des délais et des
      responsabilités mal définies.
    </p>
    <p>
      Votre mission est de gérer efficacement les émotions de l'équipe, de
      résoudre les conflits et de rétablir une collaboration productive.
    </p>

    <h2>5/ Réactivité managériale face aux crises et incertitudes </h2>
    <p>
      Impact sur les décisions : Analyse des répercussions des crises sur la
      prise de décision.
    </p>
    <p>Leadership orienté sens et dynamiser positivement l'équipe.</p>
    <p>
      Maîtrise de ses émotions : Gérer ses propres peurs et incertitudes face
      aux défis.
    </p>
    <p>
      Gestion de la résistance au changement : Identifier et soutenir les
      membres résistants lors des transitions.
    </p>
    <p>
      Partage de vision stratégique : Impliquer l'équipe dans la vision et les
      impacts des décisions récentes.
    </p>
    <p>
      Communication clé en management : Communiquer efficacement avec son équipe
      pour assurer transparence et compréhension.{" "}
    </p>
    <h2>6/ Formaliser une approche d'innovation </h2>
    <p>Analyser les objectifs et reformuler les problématiques.</p>
    <p>Générer et distinguer les idées de valeur.</p>
    <p>
      Adopter un cycle de gestion des idées incluant leur génération,
      protection, et recyclage.
    </p>
    <p>
      Évaluer et sélectionner les meilleures solutions, et les mettre en œuvre
      efficacement.
    </p>
    <h3>Exercices pratiques :</h3>
    <p>Création d’une matrice d’innovation </p>

    <h2>7/ Évaluer l'innovation</h2>
    <p>Les indicateurs qualitatifs et quantitatifs.</p>
    <p>Les indicateurs pour la cohésion d'équipe.</p>
    <p>Les indicateurs pour la motivation.</p>
    <p>Les indicateurs pour la fidélisation des talents.</p>
    <h3>Exercices pratiques :</h3>
    <p>Echanges et réflexion</p>

    <h2>Modalités pratiques</h2>
    <h3>Travaux pratiques</h3>
    <p>Mise en situation, auto prospection/diagnostic, et cas pratiques </p>

    <h3>Méthodes pédagogiques </h3>
    <p>
      Pédagogie active basée sur des échanges, une évaluation tout au long de la
      formation et de nombreux exercices de mise en application.
    </p>

    <h2>Modalités d'évaluation</h2>
    <p>
      Tout au long de la session de formation, le formateur suit l'avancement
      pédagogique du participant grâce à divers outils tels que des
      questionnaires à choix multiples, des simulations pratiques et d'autres
      exercices appliqués. De plus, le participant réalise un test de
      positionnement avant et après la formation afin de confirmer les
      compétences développées.
    </p>
  </div>
);

export default content;
